<!-- Drag-over overlay: covers the whole agent surface (sidebar + chat), dimming the
     background, while a file is dragged anywhere over it -->
@if ($isDragOver()) {
  <div class="drop-overlay">
    <div class="drop-badge">
      <i class="fa-regular fa-file-arrow-up"></i>
    </div>
    <span>Drop files here</span>
  </div>
}

<!-- Sidebar: collapses to a slim icon rail; hovering the rail peeks the full panel -->
<aside class="sidebar" [class.collapsed]="!$sidebarOpen()" [class.animate]="$sidebarAnimate()" [class.peek-suppressed]="$peekSuppressed()" [class.rail-peek]="$railPeek()" (mouseleave)="onSidebarPointerLeave()">
  <!-- Slim rail (collapsed state): primary nav as icons; hover peeks the full panel -->
  <div class="sidebar-rail">
    <!-- Rail header mirrors the expanded panel's header box (same height + border) so
         the icons below start at the same offset as the nav items do beneath the
         "Workbuddy Agent" heading when open. Doubles as a clear expand affordance. -->
    <div class="sidebar-rail-header">
      <wb-button-icon class="collapse-btn" [iconLeft]="'fa-regular fa-arrow-right-from-line'" [tooltip]="'Expand sidebar'" [displayStyle]="ButtonDisplayStyle.Tertiary" (onClick)="expandSidebar()" />
    </div>
    <div class="sidebar-rail-items" (mouseenter)="onRailPeekEnter()">
      <button type="button" class="rail-item" title="New chat" (click)="onNewChat()">
        <i class="fa-regular fa-pen-to-square"></i>
      </button>
      <button type="button" class="rail-item" title="Search chats" (click)="onSearchFromRail()">
        <i class="fa-regular fa-magnifying-glass"></i>
      </button>
      <button type="button" class="rail-item" [class.active]="$automationsOpen()" title="Automations" (click)="onSelectAutomations()">
        <i class="fa-regular fa-bolt"></i>
      </button>
    </div>
  </div>

  <!-- Full panel (expanded state, or hover-peek while collapsed) -->
  <div class="sidebar-panel">
    <div class="sidebar-header">
      <span class="sidebar-title">Workbuddy Agent</span>
      <wb-button-icon class="collapse-btn" [iconLeft]="$sidebarOpen() ? 'fa-regular fa-arrow-left-from-line' : 'fa-regular fa-arrow-right-from-line'" [tooltip]="$sidebarOpen() ? 'Collapse sidebar' : 'Expand sidebar'" [displayStyle]="ButtonDisplayStyle.Tertiary" (onClick)="toggleSidebar()" />
    </div>

    <nav class="sidebar-nav">
      <button type="button" class="nav-item" [class.active]="$isNewChatActive()" (click)="onNewChat()">
        <i class="fa-regular fa-pen-to-square nav-icon"></i>
        <span class="nav-label">New chat</span>
      </button>

      <button type="button" class="nav-item" [class.searching]="$searchActive()" (click)="toggleSearch()">
        <i class="fa-regular fa-magnifying-glass nav-icon"></i>
        <span class="nav-label">Search chats</span>
      </button>

      <!-- Slides down directly beneath the Search chats button -->
      <div class="nav-search" [class.open]="$searchActive()">
        <div class="nav-search-field">
          <i class="fa-regular fa-magnifying-glass search-icon"></i>
          <input #sidebarSearchInput type="text" class="search-input" placeholder="Search by name" [ngModel]="$searchQuery()" (ngModelChange)="$searchQuery.set($event)" />
          @if ($searchQuery()) {
            <button type="button" class="search-clear" title="Clear search" (click)="$searchQuery.set('')">
              <i class="fa-regular fa-xmark"></i>
            </button>
          }
        </div>
      </div>

      <button type="button" class="nav-item" [class.active]="$automationsOpen()" (click)="onSelectAutomations()">
        <i class="fa-regular fa-bolt nav-icon"></i>
        <span class="nav-label">Automations</span>
      </button>
    </nav>

    <div class="sidebar-body">
      <agent-thread-list [mode]="'fullscreen'" [threads]="$threads()" [activeThreadId]="$automationsOpen() ? null : $activeThreadId()" [loading]="$loading()" [threadStates]="$threadStates()" [showActiveIndicators]="false" [searchQuery]="$searchQuery()" [showInternalSearch]="false" (threadSelected)="onThreadSelected($event)" (threadDeleted)="onDeleteThread($event)" />
    </div>
  </div>
</aside>

<!-- Main content -->
<main class="main-content">
  <header class="page-header">
    <div class="page-header-left">
      <span class="page-title">{{ $headerTitle() }}</span>
    </div>
    <div class="page-header-right">
      <wb-button-icon [iconLeft]="'fa-regular fa-arrow-down-left-and-arrow-up-right-to-center'" [tooltip]="'Minimize'" [displayStyle]="ButtonDisplayStyle.Tertiary" (onClick)="onMinimize()" />
    </div>
  </header>
  <div class="main-body">
    @if ($automationsOpen()) {
      <agent-automations-placeholder />
    } @else {
      <agent-chat-container [mode]="'fullscreen'" [threadId]="$activeThreadId()" (threadChanged)="onThreadChanged($event)" (titleUpdated)="onTitleUpdated($event)" (newChatRequested)="onNewChat()" />
    }
  </div>
</main>
